// src/components/Admin/RoleUpdateModal.js
"use client";

import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import api from "../../services/api";
import toast from "react-hot-toast";

const RoleUpdateModal = ({ show, onHide, userId, currentRole, onSuccess }) => {
  const [role, setRole] = useState(currentRole || "USER");
  const [loading, setLoading] = useState(false);

  const handleUpdateRole = async () => {
    setLoading(true);
    try {
      await api.patch(`/admin/users/${userId}/role`, { role });
      toast.success("نقش کاربر با موفقیت تغییر کرد");
      onSuccess?.();
      onHide();
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "خطا در تغییر نقش");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>تغییر نقش کاربر</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>نقش جدید</Form.Label>
          <Form.Select value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="ADMIN">مدیر</option>
            <option value="STORE">فروشگاه</option>
            <option value="USER">کاربر</option>
          </Form.Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          انصراف
        </Button>
        <Button variant="primary" onClick={handleUpdateRole} disabled={loading}>
          {loading ? "در حال تغییر..." : "ذخیره تغییرات"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RoleUpdateModal;
